import { makeStyles } from '@material-ui/core';
import {GREY_INFO_COLOR, INFO_BACKGROUND, WARNING_BACKGROUND} from "../../../../themes/themeConfigurator";

export default makeStyles(theme => ({
  dialogTitle: {
    background: props => props.hasRequired ? WARNING_BACKGROUND : INFO_BACKGROUND,
  },
  infoMsg: {
    fontSize: 18,
  },
  menuName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 14,
    textTransform: 'uppercase'
  },
  stepName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
  },
  missingField: {
    fontSize: 14,
    '& .red': {
      color: '#E25443',
    }
  },
  menuContainer: {
  },
  stepContainer: {
    marginLeft: theme.spacing(2),
  },
  arrowBreadcrumb: {
    color: GREY_INFO_COLOR,
    margin: '0 0.25em',
    fontSize: '1.15em',
    verticalAlign: 'middle'
  }
}))